import { motion } from "framer-motion";
import { MaskedLines } from "./Reveal";

// Editorial page header used across interior pages.
export default function PageHeader({ overline, title, lines, intro, children }) {
  return (
    <section className="relative overflow-hidden border-b border-border bg-cream-200 pt-36 pb-16 md:pt-44 md:pb-24">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <h1 className="max-w-4xl font-display text-4xl font-semibold leading-[1.02] tracking-tight text-forest md:text-6xl">
          {lines ? <MaskedLines lines={lines} delay={0.1} /> : title}
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-forest-light md:text-lg"
          >
            {intro}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
}
